import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { MatDividerModule } from '@angular/material/divider';
import { MatIconModule } from '@angular/material/icon';
import { MatLegacyMenuModule as MatMenuModule } from '@angular/material/legacy-menu';
import { TreoNavigationModule } from 'tsui/@treo';
import { MessagesModule } from 'app/layout/common/messages/messages.module';
import { NotificationsModule } from 'app/layout/common/notifications/notifications.module';
import { SearchModule } from 'app/layout/common/search/search.module';
import { ShortcutsModule } from 'app/layout/common/shortcuts/shortcuts.module';
import { UserModule } from 'app/layout/common/user/user.module';
import { SharedModule } from 'app/shared/shared.module';
import { ModernLayoutComponent } from 'app/layout/layouts/horizontal/modern/modern.component';
import { CalculatorModule } from 'app/layout/common/calculator/calculator.module';
import { SupportHubComponent } from 'app/layout/common/support-hub/support-hub.component';
import { CelesteToggleComponent } from 'app/layout/common/celeste-toggle/celeste-toggle.component';
import { TsButtonModule, TsOverlayModule, TsPipesModule } from 'tsui';
import { DealsSidebarComponent } from 'app/modules/projects/list/deals-sidebar/deals-sidebar.component';
import { ShellActionBarComponent } from './shell-action-bar/shell-action-bar.component';
import { ShellViewLoaderComponent } from './shell-view-loader/shell-view-loader.component';
import { ShellTaskSidebarComponent } from './shell-task-sidebar/shell-task-sidebar.component';
import { ShellReportSidebarComponent } from './shell-report-sidebar/shell-report-sidebar.component';
import { ShellMenuComponent } from './shell-menu/shell-menu.component';

@NgModule({
  declarations: [ModernLayoutComponent],
  imports: [
    RouterModule,
    TsButtonModule,
    MatDividerModule,
    MatIconModule,
    MatMenuModule,
    TreoNavigationModule,
    MessagesModule,
    NotificationsModule,
    SearchModule,
    ShortcutsModule,
    UserModule,
    SharedModule,
    CalculatorModule,
    SupportHubComponent,
    CelesteToggleComponent,
    TsOverlayModule,
    DealsSidebarComponent,
    ShellActionBarComponent,
    ShellViewLoaderComponent,
    ShellTaskSidebarComponent,
    ShellReportSidebarComponent,
    TsPipesModule,
    ShellMenuComponent,
  ],
  exports: [ModernLayoutComponent],
})
export class ModernLayoutModule {}
